import $ from 'jquery';

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const domElements = {};

function carousel() {
  if (storeDomElements() === false) {
    return;
  }

  const swiper = new Swiper(domElements.slider[0], {
    slidesPerView: 1,
    spaceBetween: 0,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {},
    navigation: {
      nextEl: domElements.nextBtn[0],
      prevEl: domElements.prevBtn[0],
    },

    preventClicks: false,
    preventClicksPropagation: false,

    breakpoints: {
      500: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      730: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1209: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });

  setTimeout(() => {
    domElements.main.animate({opacity: 1}, 200);
  }, 100);

}

function storeDomElements() {
  domElements.main = $('.carousel');

  if (domElements.main.length < 1) return false;

  domElements.slider = domElements.main.find('.carousel__items');
  domElements.prevBtn = domElements.main.find('.carousel__button-prev');
  domElements.nextBtn = domElements.main.find('.carousel__button-next');

  return true;
}

export default carousel;
